import { DescribeProperty } from '../../common';

export class CustomerSessionCreateResponse {
  @DescribeProperty({
    description: 'Client secret to attach into stripe component',
  })
  clientSecret: string;
}
